export const COUNTRIES = {
  AF: 'Afghanistan',
  AX: 'Aland Islands',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BQ: 'Bonaire, Sint Eustatius and Saba',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  CV: 'Cape Verde',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CG: 'Congo',
  CD: 'Congo, Democratic Republic of the Congo',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  CI: "Cote D'Ivoire",
  HR: 'Croatia',
  CU: 'Cuba',
  CW: 'Curacao',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FK: 'Falkland Islands (Malvinas)',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island and McDonald Islands',
  VA: 'Holy See (Vatican City State)',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran, Islamic Republic of',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KP: "Korea, Democratic People's Republic of",
  KR: 'Korea, Republic of',
  XK: 'Kosovo',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: "Lao People's Democratic Republic",
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libyan Arab Jamahiriya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MK: 'Macedonia, the Former Yugoslav Republic of',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia, Federated States of',
  MD: 'Moldova, Republic of',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  AN: 'Netherlands Antilles',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestinian Territory, Occupied',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RE: 'Reunion',
  RO: 'Romania',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  BL: 'Saint Barthelemy',
  SH: 'Saint Helena',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin',
  PM: 'Saint Pierre and Miquelon',
  VC: 'Saint Vincent and the Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome and Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  CS: 'Serbia and Montenegro',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SX: 'St Martin',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia and the South Sandwich Islands',
  SS: 'South Sudan',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard and Jan Mayen',
  SZ: 'Swaziland',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan, Province of China',
  TJ: 'Tajikistan',
  TZ: 'Tanzania, United Republic of',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks and Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  US: 'United States',
  UM: 'United States Minor Outlying Islands',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Viet Nam',
  VG: 'Virgin Islands,} British',
  VI: 'Virgin Islands,} U.s.',
  WF: 'Wallis and Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe'
} as const

export const LOCALIZED_COUNTRIES = {
  AF: {
    en: 'Afghanistan',
    es: 'Afganistán',
    pt: 'Afeganistão',
  },
  AX: {
    en: 'Åland Islands',
    es: 'Islas Åland',
    pt: 'Ilhas Åland',
  },
  AL: {
    en: 'Albania',
    es: 'Albania',
    pt: 'Albânia',
  },
  DZ: {
    en: 'Algeria',
    es: 'Argelia',
    pt: 'Argélia',
  },
  AS: {
    en: 'American Samoa',
    es: 'Samoa Americana',
    pt: 'Samoa Americana',
  },
  AD: {
    en: 'Andorra',
    es: 'Andorra',
    pt: 'Andorra',
  },
  AO: {
    en: 'Angola',
    es: 'Angola',
    pt: 'Angola',
  },
  AI: {
    en: 'Anguilla',
    es: 'Anguila',
    pt: 'Anguila',
  },
  AQ: {
    en: 'Antarctica',
    es: 'Antártida',
    pt: 'Antártida',
  },
  AG: {
    en: 'Antigua and Barbuda',
    es: 'Antigua y Barbuda',
    pt: 'Antígua e Barbuda',
  },
  AR: {
    en: 'Argentina',
    es: 'Argentina',
    pt: 'Argentina',
  },
  AM: {
    en: 'Armenia',
    es: 'Armenia',
    pt: 'Armênia',
  },
  AW: {
    en: 'Aruba',
    es: 'Aruba',
    pt: 'Aruba',
  },
  AU: {
    en: 'Australia',
    es: 'Australia',
    pt: 'Austrália',
  },
  AT: {
    en: 'Austria',
    es: 'Austria',
    pt: 'Áustria',
  },
  AZ: {
    en: 'Azerbaijan',
    es: 'Azerbaiyán',
    pt: 'Azerbaijão',
  },
  BS: {
    en: 'Bahamas',
    es: 'Bahamas',
    pt: 'Bahamas',
  },
  BH: {
    en: 'Bahrain',
    es: 'Baréin',
    pt: 'Bahrein',
  },
  BD: {
    en: 'Bangladesh',
    es: 'Bangladesh',
    pt: 'Bangladesh',
  },
  BB: {
    en: 'Barbados',
    es: 'Barbados',
    pt: 'Barbados',
  },
  BY: {
    en: 'Belarus',
    es: 'Bielorrusia',
    pt: 'Bielorrússia',
  },
  BE: {
    en: 'Belgium',
    es: 'Bélgica',
    pt: 'Bélgica',
  },
  BZ: {
    en: 'Belize',
    es: 'Belice',
    pt: 'Belize',
  },
  BJ: {
    en: 'Benin',
    es: 'Benín',
    pt: 'Benin',
  },
  BM: {
    en: 'Bermuda',
    es: 'Bermudas',
    pt: 'Bermudas',
  },
  BT: {
    en: 'Bhutan',
    es: 'Bután',
    pt: 'Butão',
  },
  BO: {
    en: 'Bolivia',
    es: 'Bolivia',
    pt: 'Bolívia',
  },
  BQ: {
    en: 'Bonaire, Sint Eustatius and Saba',
    es: 'Bonaire, San Eustaquio y Saba',
    pt: 'Bonaire, Santo Eustáquio e Saba',
  },
  BA: {
    en: 'Bosnia and Herzegovina',
    es: 'Bosnia y Herzegovina',
    pt: 'Bósnia e Herzegovina',
  },
  BW: {
    en: 'Botswana',
    es: 'Botsuana',
    pt: 'Botsuana',
  },
  BV: {
    en: 'Bouvet Island',
    es: 'Isla Bouvet',
    pt: 'Ilha Bouvet',
  },
  BR: {
    en: 'Brazil',
    es: 'Brasil',
    pt: 'Brasil',
  },
  IO: {
    en: 'British Indian Ocean Territory',
    es: 'Territorio Británico del Océano Índico',
    pt: 'Território Britânico do Oceano Índico',
  },
  BN: {
    en: 'Brunei Darussalam',
    es: 'Brunéi',
    pt: 'Brunei',
  },
  BG: {
    en: 'Bulgaria',
    es: 'Bulgaria',
    pt: 'Bulgária',
  },
  BF: {
    en: 'Burkina Faso',
    es: 'Burkina Faso',
    pt: 'Burkina Faso',
  },
  BI: {
    en: 'Burundi',
    es: 'Burundi',
    pt: 'Burundi',
  },
  KH: {
    en: 'Cambodia',
    es: 'Camboya',
    pt: 'Camboja',
  },
  CM: {
    en: 'Cameroon',
    es: 'Camerún',
    pt: 'Camarões',
  },
  CA: {
    en: 'Canada',
    es: 'Canadá',
    pt: 'Canadá',
  },
  CV: {
    en: 'Cape Verde',
    es: 'Cabo Verde',
    pt: 'Cabo Verde',
  },
  KY: {
    en: 'Cayman Islands',
    es: 'Islas Caimán',
    pt: 'Ilhas Cayman',
  },
  CF: {
    en: 'Central African Republic',
    es: 'República Centroafricana',
    pt: 'República Centro-Africana',
  },
  TD: {
    en: 'Chad',
    es: 'Chad',
    pt: 'Chade',
  },
  CL: {
    en: 'Chile',
    es: 'Chile',
    pt: 'Chile',
  },
  CN: {
    en: 'China',
    es: 'China',
    pt: 'China',
  },
  CX: {
    en: 'Christmas Island',
    es: 'Isla de Navidad',
    pt: 'Ilha do Natal',
  },
  CC: {
    en: 'Cocos (Keeling) Islands',
    es: 'Islas Cocos (Keeling)',
    pt: 'Ilhas Cocos (Keeling)',
  },
  CO: {
    en: 'Colombia',
    es: 'Colombia',
    pt: 'Colômbia',
  },
  KM: {
    en: 'Comoros',
    es: 'Comoras',
    pt: 'Comores',
  },
  CG: {
    en: 'Congo',
    es: 'Congo',
    pt: 'Congo',
  },
  CD: {
    en: 'Congo, Democratic Republic of the Congo',
    es: 'Congo, República Democrática del Congo',
    pt: 'Congo, República Democrática do Congo',
  },
  CK: {
    en: 'Cook Islands',
    es: 'Islas Cook',
    pt: 'Ilhas Cook',
  },
  CR: {
    en: 'Costa Rica',
    es: 'Costa Rica',
    pt: 'Costa Rica',
  },
  CI: {
    en: "Côte d'Ivoire",
    es: 'Costa de Marfil',
    pt: 'Costa do Marfim',
  },
  HR: {
    en: 'Croatia',
    es: 'Croacia',
    pt: 'Croácia',
  },
  CU: {
    en: 'Cuba',
    es: 'Cuba',
    pt: 'Cuba',
  },
  CW: {
    en: 'Curaçao',
    es: 'Curazao',
    pt: 'Curaçao',
  },
  CY: {
    en: 'Cyprus',
    es: 'Chipre',
    pt: 'Chipre',
  },
  CZ: {
    en: 'Czech Republic',
    es: 'República Checa',
    pt: 'República Tcheca',
  },
  DK: {
    en: 'Denmark',
    es: 'Dinamarca',
    pt: 'Dinamarca',
  },
  DJ: {
    en: 'Djibouti',
    es: 'Yibuti',
    pt: 'Djibuti',
  },
  DM: {
    en: 'Dominica',
    es: 'Dominica',
    pt: 'Dominica',
  },
  DO: {
    en: 'Dominican Republic',
    es: 'República Dominicana',
    pt: 'República Dominicana',
  },
  EC: {
    en: 'Ecuador',
    es: 'Ecuador',
    pt: 'Equador',
  },
  EG: {
    en: 'Egypt',
    es: 'Egipto',
    pt: 'Egito',
  },
  SV: {
    en: 'El Salvador',
    es: 'El Salvador',
    pt: 'El Salvador',
  },
  GQ: {
    en: 'Equatorial Guinea',
    es: 'Guinea Ecuatorial',
    pt: 'Guiné Equatorial',
  },
  ER: {
    en: 'Eritrea',
    es: 'Eritrea',
    pt: 'Eritreia',
  },
  EE: {
    en: 'Estonia',
    es: 'Estonia',
    pt: 'Estônia',
  },
  ET: {
    en: 'Ethiopia',
    es: 'Etiopía',
    pt: 'Etiópia',
  },
  FK: {
    en: 'Falkland Islands (Malvinas)',
    es: 'Islas Malvinas',
    pt: 'Ilhas Malvinas',
  },
  FO: {
    en: 'Faroe Islands',
    es: 'Islas Feroe',
    pt: 'Ilhas Faroé',
  },
  FJ: {
    en: 'Fiji',
    es: 'Fiyi',
    pt: 'Fiji',
  },
  FI: {
    en: 'Finland',
    es: 'Finlandia',
    pt: 'Finlândia',
  },
  FR: {
    en: 'France',
    es: 'Francia',
    pt: 'França',
  },
  GF: {
    en: 'French Guiana',
    es: 'Guayana Francesa',
    pt: 'Guiana Francesa',
  },
  PF: {
    en: 'French Polynesia',
    es: 'Polinesia Francesa',
    pt: 'Polinésia Francesa',
  },
  TF: {
    en: 'French Southern Territories',
    es: 'Territorios Australes Franceses',
    pt: 'Territórios Franceses do Sul',
  },
  GA: {
    en: 'Gabon',
    es: 'Gabón',
    pt: 'Gabão',
  },
  GM: {
    en: 'Gambia',
    es: 'Gambia',
    pt: 'Gâmbia',
  },
  GE: {
    en: 'Georgia',
    es: 'Georgia',
    pt: 'Geórgia',
  },
  DE: {
    en: 'Germany',
    es: 'Alemania',
    pt: 'Alemanha',
  },
  GH: {
    en: 'Ghana',
    es: 'Ghana',
    pt: 'Gana',
  },
  GI: {
    en: 'Gibraltar',
    es: 'Gibraltar',
    pt: 'Gibraltar',
  },
  GR: {
    en: 'Greece',
    es: 'Grecia',
    pt: 'Grécia',
  },
  GL: {
    en: 'Greenland',
    es: 'Groenlandia',
    pt: 'Groenlândia',
  },
  GD: {
    en: 'Grenada',
    es: 'Granada',
    pt: 'Granada',
  },
  GP: {
    en: 'Guadeloupe',
    es: 'Guadalupe',
    pt: 'Guadalupe',
  },
  GU: {
    en: 'Guam',
    es: 'Guam',
    pt: 'Guam',
  },
  GT: {
    en: 'Guatemala',
    es: 'Guatemala',
    pt: 'Guatemala',
  },
  GG: {
    en: 'Guernsey',
    es: 'Guernsey',
    pt: 'Guernsey',
  },
  GN: {
    en: 'Guinea',
    es: 'Guinea',
    pt: 'Guiné',
  },
  GW: {
    en: 'Guinea-Bissau',
    es: 'Guinea-Bisáu',
    pt: 'Guiné-Bissau',
  },
  GY: {
    en: 'Guyana',
    es: 'Guyana',
    pt: 'Guiana',
  },
  HT: {
    en: 'Haiti',
    es: 'Haití',
    pt: 'Haiti',
  },
  HM: {
    en: 'Heard Island and McDonald Islands',
    es: 'Islas Heard y McDonald',
    pt: 'Ilha Heard e Ilhas McDonald',
  },
  VA: {
    en: 'Holy See (Vatican City State)',
    es: 'Santa Sede (Ciudad del Vaticano)',
    pt: 'Santa Sé (Cidade do Vaticano)',
  },
  HN: {
    en: 'Honduras',
    es: 'Honduras',
    pt: 'Honduras',
  },
  HK: {
    en: 'Hong Kong',
    es: 'Hong Kong',
    pt: 'Hong Kong',
  },
  HU: {
    en: 'Hungary',
    es: 'Hungría',
    pt: 'Hungria',
  },
  IS: {
    en: 'Iceland',
    es: 'Islandia',
    pt: 'Islândia',
  },
  IN: {
    en: 'India',
    es: 'India',
    pt: 'Índia',
  },
  ID: {
    en: 'Indonesia',
    es: 'Indonesia',
    pt: 'Indonésia',
  },
  IR: {
    en: 'Iran, Islamic Republic of',
    es: 'Irán',
    pt: 'Irã',
  },
  IQ: {
    en: 'Iraq',
    es: 'Irak',
    pt: 'Iraque',
  },
  IE: {
    en: 'Ireland',
    es: 'Irlanda',
    pt: 'Irlanda',
  },
  IM: {
    en: 'Isle of Man',
    es: 'Isla de Man',
    pt: 'Ilha de Man',
  },
  IL: {
    en: 'Israel',
    es: 'Israel',
    pt: 'Israel',
  },
  IT: {
    en: 'Italy',
    es: 'Italia',
    pt: 'Itália',
  },
  JM: {
    en: 'Jamaica',
    es: 'Jamaica',
    pt: 'Jamaica',
  },
  JP: {
    en: 'Japan',
    es: 'Japón',
    pt: 'Japão',
  },
  JE: {
    en: 'Jersey',
    es: 'Jersey',
    pt: 'Jersey',
  },
  JO: {
    en: 'Jordan',
    es: 'Jordania',
    pt: 'Jordânia',
  },
  KZ: {
    en: 'Kazakhstan',
    es: 'Kazajistán',
    pt: 'Cazaquistão',
  },
  KE: {
    en: 'Kenya',
    es: 'Kenia',
    pt: 'Quênia',
  },
  KI: {
    en: 'Kiribati',
    es: 'Kiribati',
    pt: 'Kiribati',
  },
  KP: {
    en: "Korea, Democratic People's Republic of",
    es: 'Corea del Norte',
    pt: 'Coreia do Norte',
  },
  KR: {
    en: 'Korea, Republic of',
    es: 'Corea del Sur',
    pt: 'Coreia do Sul',
  },
  XK: {
    en: 'Kosovo',
    es: 'Kosovo',
    pt: 'Kosovo',
  },
  KW: {
    en: 'Kuwait',
    es: 'Kuwait',
    pt: 'Kuwait',
  },
  KG: {
    en: 'Kyrgyzstan',
    es: 'Kirguistán',
    pt: 'Quirguistão',
  },
  LA: {
    en: "Lao People's Democratic Republic",
    es: 'Laos',
    pt: 'Laos',
  },
  LV: {
    en: 'Latvia',
    es: 'Letonia',
    pt: 'Letônia',
  },
  LB: {
    en: 'Lebanon',
    es: 'Líbano',
    pt: 'Líbano',
  },
  LS: {
    en: 'Lesotho',
    es: 'Lesoto',
    pt: 'Lesoto',
  },
  LR: {
    en: 'Liberia',
    es: 'Liberia',
    pt: 'Libéria',
  },
  LY: {
    en: 'Libyan Arab Jamahiriya',
    es: 'Libia',
    pt: 'Líbia',
  },
  LI: {
    en: 'Liechtenstein',
    es: 'Liechtenstein',
    pt: 'Liechtenstein',
  },
  LT: {
    en: 'Lithuania',
    es: 'Lituania',
    pt: 'Lituânia',
  },
  LU: {
    en: 'Luxembourg',
    es: 'Luxemburgo',
    pt: 'Luxemburgo',
  },
  MO: {
    en: 'Macao',
    es: 'Macao',
    pt: 'Macau',
  },
  MK: {
    en: 'Macedonia, the Former Yugoslav Republic of',
    es: 'Macedonia',
    pt: 'Macedônia',
  },
  MG: {
    en: 'Madagascar',
    es: 'Madagascar',
    pt: 'Madagascar',
  },
  MW: {
    en: 'Malawi',
    es: 'Malaui',
    pt: 'Malawi',
  },
  MY: {
    en: 'Malaysia',
    es: 'Malasia',
    pt: 'Malásia',
  },
  MV: {
    en: 'Maldives',
    es: 'Maldivas',
    pt: 'Maldivas',
  },
  ML: {
    en: 'Mali',
    es: 'Mali',
    pt: 'Mali',
  },
  MT: {
    en: 'Malta',
    es: 'Malta',
    pt: 'Malta',
  },
  MH: {
    en: 'Marshall Islands',
    es: 'Islas Marshall',
    pt: 'Ilhas Marshall',
  },
  MQ: {
    en: 'Martinique',
    es: 'Martinica',
    pt: 'Martinica',
  },
  MR: {
    en: 'Mauritania',
    es: 'Mauritania',
    pt: 'Mauritânia',
  },
  MU: {
    en: 'Mauritius',
    es: 'Mauricio',
    pt: 'Maurício',
  },
  YT: {
    en: 'Mayotte',
    es: 'Mayotte',
    pt: 'Mayotte',
  },
  MX: {
    en: 'Mexico',
    es: 'México',
    pt: 'México',
  },
  FM: {
    en: 'Micronesia, Federated States of',
    es: 'Micronesia',
    pt: 'Micronésia',
  },
  MD: {
    en: 'Moldova, Republic of',
    es: 'Moldavia',
    pt: 'Moldávia',
  },
  MC: {
    en: 'Monaco',
    es: 'Mónaco',
    pt: 'Mônaco',
  },
  MN: {
    en: 'Mongolia',
    es: 'Mongolia',
    pt: 'Mongólia',
  },
  ME: {
    en: 'Montenegro',
    es: 'Montenegro',
    pt: 'Montenegro',
  },
  MS: {
    en: 'Montserrat',
    es: 'Montserrat',
    pt: 'Montserrat',
  },
  MA: {
    en: 'Morocco',
    es: 'Marruecos',
    pt: 'Marrocos',
  },
  MZ: {
    en: 'Mozambique',
    es: 'Mozambique',
    pt: 'Moçambique',
  },
  MM: {
    en: 'Myanmar',
    es: 'Myanmar',
    pt: 'Mianmar',
  },
  NA: {
    en: 'Namibia',
    es: 'Namibia',
    pt: 'Namíbia',
  },
  NR: {
    en: 'Nauru',
    es: 'Nauru',
    pt: 'Nauru',
  },
  NP: {
    en: 'Nepal',
    es: 'Nepal',
    pt: 'Nepal',
  },
  NL: {
    en: 'Netherlands',
    es: 'Países Bajos',
    pt: 'Países Baixos',
  },
  AN: {
    en: 'Netherlands Antilles',
    es: 'Antillas Neerlandesas',
    pt: 'Antilhas Holandesas',
  },
  NC: {
    en: 'New Caledonia',
    es: 'Nueva Caledonia',
    pt: 'Nova Caledônia',
  },
  NZ: {
    en: 'New Zealand',
    es: 'Nueva Zelanda',
    pt: 'Nova Zelândia',
  },
  NI: {
    en: 'Nicaragua',
    es: 'Nicaragua',
    pt: 'Nicarágua',
  },
  NE: {
    en: 'Niger',
    es: 'Níger',
    pt: 'Níger',
  },
  NG: {
    en: 'Nigeria',
    es: 'Nigeria',
    pt: 'Nigéria',
  },
  NU: {
    en: 'Niue',
    es: 'Niue',
    pt: 'Niue',
  },
  NF: {
    en: 'Norfolk Island',
    es: 'Isla Norfolk',
    pt: 'Ilha Norfolk',
  },
  MP: {
    en: 'Northern Mariana Islands',
    es: 'Islas Marianas del Norte',
    pt: 'Ilhas Marianas do Norte',
  },
  NO: {
    en: 'Norway',
    es: 'Noruega',
    pt: 'Noruega',
  },
  OM: {
    en: 'Oman',
    es: 'Omán',
    pt: 'Omã',
  },
  PK: {
    en: 'Pakistan',
    es: 'Pakistán',
    pt: 'Paquistão',
  },
  PW: {
    en: 'Palau',
    es: 'Palaos',
    pt: 'Palau',
  },
  PS: {
    en: 'Palestinian Territory, Occupied',
    es: 'Territorios Palestinos',
    pt: 'Territórios Palestinos',
  },
  PA: {
    en: 'Panama',
    es: 'Panamá',
    pt: 'Panamá',
  },
  PG: {
    en: 'Papua New Guinea',
    es: 'Papúa Nueva Guinea',
    pt: 'Papua-Nova Guiné',
  },
  PY: {
    en: 'Paraguay',
    es: 'Paraguay',
    pt: 'Paraguai',
  },
  PE: {
    en: 'Peru',
    es: 'Perú',
    pt: 'Peru',
  },
  PH: {
    en: 'Philippines',
    es: 'Filipinas',
    pt: 'Filipinas',
  },
  PN: {
    en: 'Pitcairn',
    es: 'Islas Pitcairn',
    pt: 'Ilhas Pitcairn',
  },
  PL: {
    en: 'Poland',
    es: 'Polonia',
    pt: 'Polônia',
  },
  PT: {
    en: 'Portugal',
    es: 'Portugal',
    pt: 'Portugal',
  },
  PR: {
    en: 'Puerto Rico',
    es: 'Puerto Rico',
    pt: 'Porto Rico',
  },
  QA: {
    en: 'Qatar',
    es: 'Catar',
    pt: 'Catar',
  },
  RE: {
    en: 'Reunion',
    es: 'Reunión',
    pt: 'Reunião',
  },
  RO: {
    en: 'Romania',
    es: 'Rumania',
    pt: 'Romênia',
  },
  RU: {
    en: 'Russian Federation',
    es: 'Rusia',
    pt: 'Rússia',
  },
  RW: {
    en: 'Rwanda',
    es: 'Ruanda',
    pt: 'Ruanda',
  },
  BL: {
    en: 'Saint Barthélemy',
    es: 'San Bartolomé',
    pt: 'São Bartolomeu',
  },
  SH: {
    en: 'Saint Helena',
    es: 'Santa Elena',
    pt: 'Santa Helena',
  },
  KN: {
    en: 'Saint Kitts and Nevis',
    es: 'San Cristóbal y Nieves',
    pt: 'São Cristóvão e Névis',
  },
  LC: {
    en: 'Saint Lucia',
    es: 'Santa Lucía',
    pt: 'Santa Lúcia',
  },
  MF: {
    en: 'Saint Martin',
    es: 'San Martín',
    pt: 'São Martinho',
  },
  PM: {
    en: 'Saint Pierre and Miquelon',
    es: 'San Pedro y Miquelón',
    pt: 'São Pedro e Miquelão',
  },
  VC: {
    en: 'Saint Vincent and the Grenadines',
    es: 'San Vicente y las Granadinas',
    pt: 'São Vicente e Granadinas',
  },
  WS: {
    en: 'Samoa',
    es: 'Samoa',
    pt: 'Samoa',
  },
  SM: {
    en: 'San Marino',
    es: 'San Marino',
    pt: 'San Marino',
  },
  ST: {
    en: 'Sao Tome and Principe',
    es: 'Santo Tomé y Príncipe',
    pt: 'São Tomé e Príncipe',
  },
  SA: {
    en: 'Saudi Arabia',
    es: 'Arabia Saudita',
    pt: 'Arábia Saudita',
  },
  SN: {
    en: 'Senegal',
    es: 'Senegal',
    pt: 'Senegal',
  },
  RS: {
    en: 'Serbia',
    es: 'Serbia',
    pt: 'Sérvia',
  },
  CS: {
    en: 'Serbia and Montenegro',
    es: 'Serbia y Montenegro',
    pt: 'Sérvia e Montenegro',
  },
  SC: {
    en: 'Seychelles',
    es: 'Seychelles',
    pt: 'Seicheles',
  },
  SL: {
    en: 'Sierra Leone',
    es: 'Sierra Leona',
    pt: 'Serra Leoa',
  },
  SG: {
    en: 'Singapore',
    es: 'Singapur',
    pt: 'Singapura',
  },
  SX: {
    en: 'Sint Maarten',
    es: 'San Martín',
    pt: 'São Martinho',
  },
  SK: {
    en: 'Slovakia',
    es: 'Eslovaquia',
    pt: 'Eslováquia',
  },
  SI: {
    en: 'Slovenia',
    es: 'Eslovenia',
    pt: 'Eslovênia',
  },
  SB: {
    en: 'Solomon Islands',
    es: 'Islas Salomón',
    pt: 'Ilhas Salomão',
  },
  SO: {
    en: 'Somalia',
    es: 'Somalia',
    pt: 'Somália',
  },
  ZA: {
    en: 'South Africa',
    es: 'Sudáfrica',
    pt: 'África do Sul',
  },
  GS: {
    en: 'South Georgia and the South Sandwich Islands',
    es: 'Islas Georgias del Sur y Sandwich del Sur',
    pt: 'Ilhas Geórgia do Sul e Sandwich do Sul',
  },
  SS: {
    en: 'South Sudan',
    es: 'Sudán del Sur',
    pt: 'Sudão do Sul',
  },
  ES: {
    en: 'Spain',
    es: 'España',
    pt: 'Espanha',
  },
  LK: {
    en: 'Sri Lanka',
    es: 'Sri Lanka',
    pt: 'Sri Lanka',
  },
  SD: {
    en: 'Sudan',
    es: 'Sudán',
    pt: 'Sudão',
  },
  SR: {
    en: 'Suriname',
    es: 'Surinam',
    pt: 'Suriname',
  },
  SJ: {
    en: 'Svalbard and Jan Mayen',
    es: 'Svalbard y Jan Mayen',
    pt: 'Svalbard e Jan Mayen',
  },
  SZ: {
    en: 'Swaziland',
    es: 'Suazilandia',
    pt: 'Essuatíni',
  },
  SE: {
    en: 'Sweden',
    es: 'Suecia',
    pt: 'Suécia',
  },
  CH: {
    en: 'Switzerland',
    es: 'Suiza',
    pt: 'Suíça',
  },
  SY: {
    en: 'Syrian Arab Republic',
    es: 'Siria',
    pt: 'Síria',
  },
  TW: {
    en: 'Taiwan, Province of China',
    es: 'Taiwán',
    pt: 'Taiwan',
  },
  TJ: {
    en: 'Tajikistan',
    es: 'Tayikistán',
    pt: 'Tajiquistão',
  },
  TZ: {
    en: 'Tanzania, United Republic of',
    es: 'Tanzania',
    pt: 'Tanzânia',
  },
  TH: {
    en: 'Thailand',
    es: 'Tailandia',
    pt: 'Tailândia',
  },
  TL: {
    en: 'Timor-Leste',
    es: 'Timor Oriental',
    pt: 'Timor-Leste',
  },
  TG: {
    en: 'Togo',
    es: 'Togo',
    pt: 'Togo',
  },
  TK: {
    en: 'Tokelau',
    es: 'Tokelau',
    pt: 'Tokelau',
  },
  TO: {
    en: 'Tonga',
    es: 'Tonga',
    pt: 'Tonga',
  },
  TT: {
    en: 'Trinidad and Tobago',
    es: 'Trinidad y Tobago',
    pt: 'Trinidad e Tobago',
  },
  TN: {
    en: 'Tunisia',
    es: 'Túnez',
    pt: 'Tunísia',
  },
  TR: {
    en: 'Turkey',
    es: 'Turquía',
    pt: 'Turquia',
  },
  TM: {
    en: 'Turkmenistan',
    es: 'Turkmenistán',
    pt: 'Turcomenistão',
  },
  TC: {
    en: 'Turks and Caicos Islands',
    es: 'Islas Turcas y Caicos',
    pt: 'Ilhas Turcas e Caicos',
  },
  TV: {
    en: 'Tuvalu',
    es: 'Tuvalu',
    pt: 'Tuvalu',
  },
  UG: {
    en: 'Uganda',
    es: 'Uganda',
    pt: 'Uganda',
  },
  UA: {
    en: 'Ukraine',
    es: 'Ucrania',
    pt: 'Ucrânia',
  },
  AE: {
    en: 'United Arab Emirates',
    es: 'Emiratos Árabes Unidos',
    pt: 'Emirados Árabes Unidos',
  },
  GB: {
    en: 'United Kingdom',
    es: 'Reino Unido',
    pt: 'Reino Unido',
  },
  US: {
    en: 'United States',
    es: 'Estados Unidos',
    pt: 'Estados Unidos',
  },
  UM: {
    en: 'United States Minor Outlying Islands',
    es: 'Islas Ultramarinas Menores de Estados Unidos',
    pt: 'Ilhas Menores Distantes dos Estados Unidos',
  },
  UY: {
    en: 'Uruguay',
    es: 'Uruguay',
    pt: 'Uruguai',
  },
  UZ: {
    en: 'Uzbekistan',
    es: 'Uzbekistán',
    pt: 'Uzbequistão',
  },
  VU: {
    en: 'Vanuatu',
    es: 'Vanuatu',
    pt: 'Vanuatu',
  },
  VE: {
    en: 'Venezuela',
    es: 'Venezuela',
    pt: 'Venezuela',
  },
  VN: {
    en: 'Viet Nam',
    es: 'Vietnam',
    pt: 'Vietnã',
  },
  VG: {
    en: 'Virgin Islands, British',
    es: 'Islas Vírgenes Británicas',
    pt: 'Ilhas Virgens Britânicas',
  },
  VI: {
    en: 'Virgin Islands, U.S.',
    es: 'Islas Vírgenes de los Estados Unidos',
    pt: 'Ilhas Virgens Americanas',
  },
  WF: {
    en: 'Wallis and Futuna',
    es: 'Wallis y Futuna',
    pt: 'Wallis e Futuna',
  },
  EH: {
    en: 'Western Sahara',
    es: 'Sáhara Occidental',
    pt: 'Saara Ocidental',
  },
  YE: {
    en: 'Yemen',
    es: 'Yemen',
    pt: 'Iêmen',
  },
  ZM: {
    en: 'Zambia',
    es: 'Zambia',
    pt: 'Zâmbia',
  },
  ZW: {
    en: 'Zimbabwe',
    es: 'Zimbabue',
    pt: 'Zimbábue',
  },
} as const